import { type RichContent } from '@wix/ricos';
import React from 'react';

import { useConfig } from '../../contexts/config-context';
import { useFieldPropsV2 } from '../../contexts/field-props-context';

interface RichTextProps {
  children: (props: {
    content: RichContent;
    locale: string;
  }) => React.ReactNode;
}

const RichText = ({ children }: RichTextProps) => {
  const { id, FieldLayout, content } = useFieldPropsV2<any>();
  const { language } = useConfig();

  return (
    <FieldLayout
      fieldId={id}
      renderLabel={() => null}
      renderInput={() => children({ content, locale: language })}
      renderDescription={() => null}
    />
  );
};

export { RichText };
